import RelanceView from "@features/comptabilite/components/relances/RelanceView";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";

function RelanceViewPage() {
  const { id } = useParams({ from: Route.id });
  return <RelanceView id={id} />;
}

export const Route = createFileRoute("/_app/comptabilite/relances/$id/view")({
  staticData: {
    title: "Détails Relance",
    icon: AlertTriangle,
    showInBreadcrumb: true,
  },
  component: RelanceViewPage,
});
